/**
 * Brand tokens — defaults from the AGEON Brand Book.
 *
 * Step 3's Brand Editor will write to AppSetting in MongoDB; the frontend
 * pulls it at boot, applies via applyTheme() (see theme/applyTheme.js),
 * which sets the matching CSS variables on <html>. This keeps Tailwind
 * class names stable while colors swap live.
 */
export const DEFAULT_TOKENS = {
    brand: {
        teal:       '#00B09B',
        teal_700:   '#008c7c',
        teal_50:    '#e6f7f4',
        yellow:     '#FFCA05',
        red:        '#C3161C',
        dark:       '#231F20',
        orange:     '#D97121',
        gold:       '#F7CC1F',
        ivory:      '#F5F1EA',
    },
    ink: {
        900: '#0f1115',
        700: '#3a3f47',
        500: '#6b7280',
        300: '#cdd2d8',
        100: '#f3f4f6',
         50: '#f9fafb',
    },
    fontHeading: '"Avenir Next", Avenir, Mulish, system-ui, sans-serif',
    fontBody:    '"Avenir Next", Avenir, Mulish, system-ui, sans-serif',
    radius:      '12',          // px
    density:     'comfortable', // 'comfortable' | 'compact'
};
